import * as React from 'react'
import { StatusOption } from './types'

interface StatusFilterProps {
  statusOptions: StatusOption[]
  selectedStatuses: string[]
  onToggleStatus: (status: string) => void
}

function StatusFilter({
  statusOptions,
  selectedStatuses,
  onToggleStatus,
}: StatusFilterProps) {
  const selectedStatusValues = selectedStatuses || []

  return (
    <div className="status-filter d-flex flex-wrap justify-content-end align-items-center">
      {statusOptions.map((option) => {
        const isSelected = selectedStatusValues.includes(option.value)

        return (
          <label
            key={option.value}
            className="d-flex align-items-center ml-3 mb-0"
            style={{ cursor: 'pointer' }}
          >
            <input
              type="checkbox"
              checked={isSelected}
              onChange={() => onToggleStatus(option.value)}
              style={{ marginRight: '4px' }}
            />
            {option.label}
          </label>
        )
      })}
    </div>
  )
}

export default StatusFilter
